/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbConseillerPedagogiqueMetiersLiesGridDto } from './FcbConseillerPedagogiqueMetiersLiesGridDto';
import {
    FcbConseillerPedagogiqueMetiersLiesGridDtoFromJSON,
    FcbConseillerPedagogiqueMetiersLiesGridDtoFromJSONTyped,
    FcbConseillerPedagogiqueMetiersLiesGridDtoToJSON,
} from './FcbConseillerPedagogiqueMetiersLiesGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbConseillerPedagogiqueMetiersLiesGridDtoPaginatedResults
 */
export interface FcbConseillerPedagogiqueMetiersLiesGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbConseillerPedagogiqueMetiersLiesGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbConseillerPedagogiqueMetiersLiesGridDto>}
     * @memberof FcbConseillerPedagogiqueMetiersLiesGridDtoPaginatedResults
     */
    results?: Array<FcbConseillerPedagogiqueMetiersLiesGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbConseillerPedagogiqueMetiersLiesGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbConseillerPedagogiqueMetiersLiesGridDtoPaginatedResults interface.
 */
export function instanceOfFcbConseillerPedagogiqueMetiersLiesGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbConseillerPedagogiqueMetiersLiesGridDtoPaginatedResultsFromJSON(json: any): FcbConseillerPedagogiqueMetiersLiesGridDtoPaginatedResults {
    return FcbConseillerPedagogiqueMetiersLiesGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbConseillerPedagogiqueMetiersLiesGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbConseillerPedagogiqueMetiersLiesGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbConseillerPedagogiqueMetiersLiesGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbConseillerPedagogiqueMetiersLiesGridDtoPaginatedResultsToJSON(value?: FcbConseillerPedagogiqueMetiersLiesGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbConseillerPedagogiqueMetiersLiesGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

